export const GET_CALENDAR_SETTINGS = 'SETTINGS: GET_CALENDAR_SETTINGS';
export const GET_CALENDAR_SETTINGS_SUCCESS =
    'SETTINGS: GET_CALENDAR_SETTINGS_SUCCESS';
export const GET_CALENDAR_SETTINGS_FAILURE =
    'SETTINGS: GET_CALENDAR_SETTINGS_FAILURE';

//Announcement actions
export const GET_ANNOUNCEMENTS = 'ANNOUNCEMENTS: GET_ANNOUNCEMENTS';
export const GET_ANNOUNCEMENTS_SUCCESS =
    'ANNOUNCEMENTS: GET_ANNOUNCEMENTS_SUCCESS';
export const GET_ANNOUNCEMENTS_FAILURE =
    'ANNOUNCEMENTS: GET_ANNOUNCEMENTS_FAILURE';

export const SET_CALENDAR_SETTINGS = 'SETTINGS: SET_CALENDAR_SETTINGS';
export const SET_CALENDAR_SETTINGS_SUCCESS =
    'SETTINGS: SET_CALENDAR_SETTINGS_SUCCESS';
export const SET_CALENDAR_SETTINGS_FAILURE =
    'SETTINGS: SET_CALENDAR_SETTINGS_FAILURE';
export const SET_IS_DELETE = 'SET_IS_DELETE';
export const SET_VIEW_VALUES = 'SET_VIEW_VALUES';
export const SET_CHECKBOX_VALUES = 'SET_CHECKBOX_VALUES';
//get new calendar sharing link action
export const GENERATE_NEW_CALENDAR_SHARING_LINK =
    'SETTINGS: GENERATE_NEW_CALENDAR_SHARING_LINK';
export const UPDATED_CALENDAR_SHARE_LINK_SUCCESS =
    'SETTINGS: UPDATED_CALENDAR_SHARE_LINK_SUCCESS';
export const UPDATED_CALENDAR_SHARE_LINK_FAILURE =
    'SETTINGS: UPDATED_CALENDAR_SHARE_LINK_FAILURE';
export const CLEAR_CALENDAR_SHARING_LINK =
    'SETTINGS: UPDATED_CALENDAR_SHARE_LINK_FAILURE';

export const IS_SETTING_PAGE_UPDATE = 'SETTINGS: IS_SETTING_PAGE_UPDATE';
export const IS_GENERATED_LINK_UPDATE = 'SETTINGS: IS_GENERATED_LINK_UPDATE';
export const UPDATE_TURN_ON_GENERATED_LINK =
    'SETTINGS: UPDATE_TURN_ON_GENERATED_LINK';
//Cancel CalendarSharing
export const SET_CANCEL_CALENDAR_SHARING =
    'SETTINGS: SET_CANCEL_CALENDAR_SHARING';
export const CANCEL_CALENDAR_SHARING_SUCCESS =
    'SETTINGS: CANCEL_CALENDAR_SHARING_SUCCESS';
export const CANCEL_CALENDAR_SHARING_FAILURE =
    'SETTINGS: CANCEL_CALENDAR_SHARING_FAILURE';
export const SET_SETTINGS_POP_UP = 'SETTINGS: SET_SETTINGS_POP_UP';
//accounts
export const GET_ACCOUNT_DATA = 'GET_ACCOUNT_DATA';
export const GET_ACCOUNT_DATA_SUCCESS = 'GET_ACCOUNT_DATA_SUCCESS';
export const GET_ACCOUNT_DATA_FAILURE = 'GET_ACCOUNT_DATA_FAILURE';

export const SET_ACCOUNT_FILTER = 'SET_ACCOUNT_FILTER';

export const SET_ACCOUNT_SEARCH = 'SET_ACCOUNT_SEARCH';
export const GET_FILTER_DATA = 'GET_FILTER_DATA';
export const GET_ACCOUNT_DETAILS = 'GET_ACCOUNT_DETAILS';
export const GET_ACCOUNT_DETAILS_SUCCESS = 'GET_ACCOUNT_DETAILS_SUCCESS';
export const GET_ACCOUNT_DETAILS_FAILURE = 'GET_ACCOUNT_DETAILS_FAILURE';
export const SHOW_POPUP = 'SHOW_POPUP';
export const SELECTED_ACCOUNT_DETAILS = 'SELECTED_ACCOUNT_DETAILS';
export const UPDATE_ACCOUNT_DETAILS = 'UPDATE_ACCOUNT_DETAILS';
export const UPDATE_ACCOUNT_DETAILS_SUCCESS = 'UPDATE_ACCOUNT_DETAILS_SUCCESS';
export const UPDATE_ACCOUNT_DETAILS_FAILURE = 'UPDATE_ACCOUNT_DETAILS_FAILURE';
export const GET_DISTRICT_SUCCESS = 'GET_DISTRICT_SUCCESS';
export const GET_DISTRICT_FAILURE = 'GET_DISTRICT_FAILURE';
export const GET_TERRITORY_SUCCESS = 'GET_TERRITORY_SUCCESS';
export const GET_TERRITORY_FAILURE = 'GET_TERRITORY_FAILURE';
export const GET_ACCOUNTS_SUCCESS = 'GET_ACCOUNTS_SUCCESS';
export const GET_ACCOUNTS_FAILURE = 'GET_ACCOUNTS_FAILURE';
export const GET_DETAILED_PRODUCT_TEMPLATE_LIST =
    'MORE: GET_DETAILED_PRODUCT_TEMPLATE_LIST';
//shipToAddress
// export const GET_SHIP_TO_ADDRESS_DATA = 'GET_SHIP_TO_ADDRESS_DATA';
// export const GET_SHIP_TO_ADDRESS_SUCCESS = 'GET_SHIP_TO_ADDRESS_SUCCESS';
// export const GET_SHIP_TO_ADDRESS_FAILURE = 'GET_SHIP_TO_ADDRESS_FAILURE';

export const SET_UNSAVED_CHANGES = 'SET_UNSAVED_CHANGES';
export const SET_COMMON_CANCEL = 'SET_COMMON_CANCEL';
export const SET_SHOW_UNSAVED = 'SET_SHOW_UNSAVED';
export const SET_ISEDIT = 'SET_ISEDIT';

export const SET_FAVORITE = 'SET_FAVORITE';
export const SET_FAVORITE_SUCCESS = 'SET_FAVORITE_SUCCESS';
export const SET_FAVORITE_FAILURE = 'SET_FAVORITE_FAILURE';
export const SET_SEARCH_PARAMS = 'SET_SEARCH_PARAMS';
export const SET_SHOW_EXPANDED_VIEW = 'SET_SHOW_EXPANDED_VIEW';

export const SET_FILTER_VIEW = 'SET_FILTER_VIEW';
export const SET_FILTER_VIEW_PHYSICIAN = 'SET_FILTER_VIEW_PHYSICIAN';
export const SET_MORE_CLICK = 'SET_MORE_CLICK';

export const GET_LINKS = 'GET_LINKS';
export const GET_LINKS_SUCCESS = 'GET_LINKS_SUCCESS';
export const GET_LINKS_FAILURE = 'GET_LINKS_FAILURE';

export const SET_CLEAR_FILTER = 'SET_CLEAR_FILTER';

export const GET_PHYSICIAN_DATA = 'GET_PHYSICIAN_DATA';
export const GET_PHYSICIAN_DATA_SUCCESS = 'GET_PHYSICIAN_DATA_SUCCESS';
export const GET_PHYSICIAN_DATA_FAILURE = 'GET_PHYSICIAN_DATA_FAILURE';

export const GET_PHYSICIAN_DETAILS = 'GET_PHYSICIAN_DETAILS';
export const GET_PHYSICIAN_DETAILS_SUCCESS = 'GET_PHYSICIAN_DETAILS_SUCCESS';
export const GET_PHYSICIAN_DETAILS_FAILURE = 'GET_PHYSICIAN_DETAILS_FAILURE';

export const SET_FAVORITE_PHYSICIAN = 'SET_FAVORITE_PHYSICIAN';
export const SET_FAVORITE_PHYSICIAN_FAILURE = 'SET_FAVORITE_PHYSICIAN_FAILURE';
export const SET_FAVORITE_PHYSICIAN_SUCCESS = 'SET_FAVORITE_PHYSICIAN_SUCCESS';
export const UPDATE_PHYSICIAN_NOTE = 'UPDATE_PHYSICIAN_NOTE';
export const UPDATE_PHYSICIAN_NOTE_SUCCESS = 'UPDATE_PHYSICIAN_NOTE_SUCCESS';
export const UPDATE_PHYSICIAN_NOTE_FAILURE = 'UPDATE_PHYSICIAN_NOTE_FAILURE';

export const SET_PHYSICIAN_SEARCH = 'SET_PHYSICIAN_SEARCH';
export const SET_PHYSICIAN_FILTER = 'SET_PHYSICIAN_FILTER';
export const SET_SEARCH_PARAMS_PHY = 'SET_SEARCH_PARAMS_PHY';
export const SET_TEMPLATE_SEARCH = 'SET_TEMPLATE_SEARCH';

export const SET_PHYSICIAN_DETAIL_TAB = 'SET_PHYSICIAN_DETAIL_TAB';
export const CLOSE_PHYSICIAN_POPUP = 'CLOSE_PHYSICIAN_POPUP';
export const SHOW_ACCOUNT_DETAIL_POPUP = 'SHOW_ACCOUNT_DETAIL_POPUP';
export const SET_ACCOUNT_DETAIL_TAB = 'SET_ACCOUNT_DETAIL_TAB';

export const GET_DISTRICT = 'GET_DISTRICT';
export const GET_DISTRICT_PHYSICIAN = 'GET_DISTRICT_PHYSICIAN';
export const GET_DISTRICT_PHYSICIAN_SUCCESS = 'GET_DISTRICT_PHYSICIAN_SUCCESS';
export const GET_DISTRICT_PHYSICIAN_FAILURE = 'GET_DISTRICT_PHYSICIAN_FAILURE';
export const GET_TERRITORY = 'GET_TERRITORY';
export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const RESET_ACCOUNTS = 'RESET_ACCOUNTS';
export const RESET_TERRITORY = 'RESET_TERRITORY';
export const RESET_ACCOUNT_FILTER_STATE = 'RESET_ACCOUNT_FILTER_STATE';
export const RESTORE_ACCOUNT_FILTER_STATE = 'RESTORE_ACCOUNT_FILTER_STATE';
export const RESET_PHYSICIAN_FILTER_STATE = 'RESET_PHYSICIAN_FILTER_STATE';
export const RESTORE_PHYSICIAN_FILTER_STATE = 'RESTORE_PHYSICIAN_FILTER_STATE';
export const SET_APPLIED_VIEW_ACCOUNT_FILTER =
    'SET_APPLIED_VIEW_ACCOUNT_FILTER';
export const SET_FILTER_TYPE = 'SET_FILTER_TYPE';
export const CLOSE_ACCOUNT_POPUP = 'CLOSE_ACCOUNT_POPUP';

export const SET_SPECIALITY_LIST = 'SET_SPECIALITY_LIST';
// export const SET_SHOW_EXPANDED_VIEW = 'SET_SHOW_EXPANDED_VIEW';
export const SET_FAVORITE_ASSOCIATE_SUCCESS = 'SET_FAVORITE_ASSOCIATE_SUCCESS';
export const SET_FAVORITE_ASSOCIATE_PHYSICIAN_SUCCESS =
    'SET_FAVORITE_ASSOCIATE_PHYSICIAN_SUCCESS';

export const SET_ACCOUNT_FILTERS = 'SET_ACCOUNT_FILTERS';
export const SET_ACCOUNT_EXPAND_VIEW = 'SET_ACCOUNT_EXPAND_VIEW';
export const SET_FILTER_PARAMS = 'SET_FILTER_PARAMS';
export const SET_PHYSICIAN_ACCOUNT_FILTER = 'SET_PHYSICIAN_ACCOUNT_FILTER';
export const SET_ACCOUNT_FILTER_SNAPSHOT = 'SET_ACCOUNT_FILTER_SNAPSHOT';
export const SET_PHYSICIAN_FILTER_SNAPSHOT = 'SET_PHYSICIAN_FILTER_SNAPSHOT';
export const SET_TEMPLATE_FILTER_SNAPSHOT = 'SET_TEMPLATE_FILTER_SNAPSHOT';
export const SET_SPECIALTY_FILTER_DATA = 'SET_SPECIALTY_FILTER_DATA';
export const SET_SPECIALTY_EXPAND = 'SET_SPECIALTY_EXPAND';
export const SET_POPUPCLOSE_FROM_HEADER = 'SET_POPUPCLOSE_FROM_HEADER';

export const SET_CLEAR_PHYSICIAN_DETAILS = 'SET_CLEAR_PHYSICIAN_DETAILS';
export const SET_SELECTED_PHYSICIAN = 'SET_SELECTED_PHYSICIAN';
export const SET_SELECTED_OPTION = 'SET_SELECTED_OPTION';
export const SET_LOCAL_EXPANDED_VIEW = 'SET_LOCAL_EXPANDED_VIEW';
export const SET_SURGERY_SCREEN = 'SET_SURGERY_SCREEN';
export const SET_EQUITY_SCREEN = 'SET_EQUITY_SCREEN';
export const SET_ACCOUNT_FAVORITE_PHYSICIAN_SUCCESS =
    'SET_ACCOUNT_FAVORITE_PHYSICIAN_SUCCESS';

export const GET_PRODUCTSTEMPLATESFILTER_SUCCESS =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_SUCCESS';
export const GET_PRODUCTSTEMPLATESFILTER_FAILURE =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER_FAILURE';
export const GET_PRODUCTSTEMPLATESFILTER =
    'PRODUCTSTEMPLATESFILTER:GET_PRODUCTSTEMPLATESFILTER';
export const SET_PRODUCTSTEMPLATESFILTER =
    'PRODUCTSTEMPLATESFILTER:SET_PRODUCTSTEMPLATESFILTER';
export const SET_PRODUCT_TEMPLATE_REFINE_DATA =
    'SET_PRODUCT_TEMPLATE_REFINE_DATA';
export const SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST =
    'SET_PRODCUCT_TEMPLATE_SUB_CATEGORY_LIST';
export const SET_EXPANDED_FILTER_VIEW = 'SET_EXPANDED_FILTER_VIEW';
export const GET_ACCOUNT_DATA_FROM_SEARCH_SUCCESS =
    'GET_ACCOUNT_DATA_FROM_SEARCH_SUCCESS';

export const GET_ACCOUNT_DATA_FROM_SEARCH = 'GET_ACCOUNT_DATA_FROM_SEARCH';
export const SET_PHYSICIAN_POPUPCLOSE_FROM_HEADER =
    'SET_PHYSICIAN_POPUPCLOSE_FROM_HEADER';
export const GET_PHYSICIAN_FROM_SEARCH_DATA_SUCCESS =
    'GET_PHYSICIAN_FROM_SEARCH_DATA_SUCCESS';
export const GET_PHYSICIAN_DATA_FROM_SEARCH = 'GET_PHYSICIAN_DATA_FROM_SEARCH';
export const PHY_FILTER_OPEN = 'PHY_FILTER_OPEN';
export const SET_APPLIED_VIEW_PHY_FILTER = 'SET_APPLIED_VIEW_PHY_FILTER';

export const SET_SHIP_TO_ADDRESS_EDIT = 'SET_SHIP_TO_ADDRESS_EDIT';

export const SET_ACCOUNT_FILTER_PARAM_VALUES =
    'SET_ACCOUNT_FILTER_PARAM_VALUES';
export const SET_PHYSICIAN_FILTER_PARAM_VALUES =
    'SET_PHYSICIAN_FILTER_PARAM_VALUES';

export const SET_FILTER_PAGE = 'SET_FILTER_PAGE';
export const SET_FAVORITE_SEARCH_SUCCESS = 'SET_FAVORITE_SEARCH_SUCCESS';
export const SET_ACCOUNT_FAVORITE_PHYSICIAN_SEARCH_SUCCESS =
    'SET_ACCOUNT_FAVORITE_PHYSICIAN_SEARCH_SUCCESS';
export const SET_UNSAVED_CHANGES_PHYSICIAN = 'SET_UNSAVED_CHANGES_PHYSICIAN';
export const SET_SHOW_UNSAVED_PHYSICIAN = 'SET_SHOW_UNSAVED_PHYSICIAN';
export const SET_SHOW_POPUP_PHYSICIAN = 'SET_SHOW_POPUP_PHYSICIAN';
export const SET_FROM_ACCOUNT_SEARCH = 'SET_FROM_ACCOUNT_SEARCH';
export const GET_PHYSICIAN_FAV_STATUS = 'GET_PHYSICIAN_FAV_STATUS';
export const GET_PHYSICIAN_FAV_STATUS_SUCCESS =
    'GET_PHYSICIAN_FAV_STATUS_SUCCESS';
export const GET_PHYSICIAN_FAV_STATUS_FAILURE =
    'GET_PHYSICIAN_FAV_STATUS_FAILURE';
export const GET_ACCOUNT_FAV_STATUS = 'GET_PHYSICIAN_FAV_STATUS';
export const GET_ACCOUNT_FAV_STATUS_SUCCESS = 'GET_ACCOUNT_FAV_STATUS_SUCCESS';
export const GET_ACCOUNT_FAV_STATUS_FAILURE = 'GET_ACCOUNT_FAV_STATUS_FAILURE';

export const GET_ACCOUNTS_LIST = 'GET_ACCOUNTS_LIST';
export const GET_ACCOUNTS_LIST_FAILURE = 'GET_ACCOUNTS_LIST_FAILURE';
export const GET_ACCOUNTS_LIST_SUCCESS = 'GET_ACCOUNTS_LIST_SUCCESS';
export const RESET_ACCOUNTS_LIST = 'RESET_ACCOUNTS_LIST';

export const GET_SPECIALTY_FILTER_DATA = 'GET_SPECIALTY_FILTER_DATA';
export const GET_SPECIALTY_FILTER_DATA_SUCCESS =
    'GET_SPECIALTY_FILTER_DATA_SUCCESS';
export const GET_SPECIALTY_FILTER_DATA_FAILURE =
    'GET_SPECIALTY_FILTER_DATA_FAILURE';

export const SET_TEMPLATE_NOTE = 'SET_TEMPLATE_NOTE';
export const SET_TEMPLATE_NOTE_ACCOUNT = 'SET_TEMPLATE_NOTE_ACCOUNT';
export const SET_TEMPLATE_NOTE_CHANGE_ACCOUNT =
    'SET_TEMPLATE_NOTE_CHANGE_ACCOUNT';
export const SET_TEMPLATE_NOTE_CHANGE_PHYSICIAN =
    'SET_TEMPLATE_NOTE_CHANGE_PHYSICIAN';
export const SET_ANNOUNCEMENT_UNSAVED_CHANGES_POP_UP =
    'SET_ANNOUNCEMENT_UNSAVED_CHANGES_POP_UP';
export const SET_ROUTE_PATH_FOR_ANNOUNCEMENT_UNSAVED_CHANGES_POP_UP =
    'SET_ROUTE_PATH_FOR_ANNOUNCEMENT_UNSAVED_CHANGES_POP_UP';
export const SET_ACCOUNT_UNSAVED_CHANGES_POP_UP =
    'SET_ACCOUNT_UNSAVED_CHANGES_POP_UP';
export const SET_ROUTE_PATH_FOR_ACCOUNT_UNSAVED_CHANGES_POP_UP =
    'SET_ROUTE_PATH_FOR_ACCOUNT_UNSAVED_CHANGES_POP_UP';
export const SET_LINKS_UNSAVED_CHANGES_POP_UP =
    'SET_LINKS_UNSAVED_CHANGES_POP_UP';
export const SET_ROUTE_PATH_FOR_LINKS_UNSAVED_CHANGES_POP_UP =
    'SET_ROUTE_PATH_FOR_LINKS_UNSAVED_CHANGES_POP_UP';
export const SET_PROXIES_UNSAVED_CHANGES_POP_UP =
    'SET_PROXIES_UNSAVED_CHANGES_POP_UP';
export const SET_ROUTE_PATH_FOR_PROXIES_UNSAVED_CHANGES_POP_UP =
    'SET_ROUTE_PATH_FOR_PROXIES_UNSAVED_CHANGES_POP_UP';
export const SET_PHYSICIANS_UNSAVED_CHANGES_POP_UP =
    'SET_PHYSICIANS_UNSAVED_CHANGES_POP_UP';
export const SET_ROUTE_PATH_FOR_PHYSICIANS_UNSAVED_CHANGES_POP_UP =
    'SET_ROUTE_PATH_FOR_PHYSICIANS_UNSAVED_CHANGES_POP_UP';
export const SET_PRODUCTGUIDE_UNSAVED_CHANGES_POP_UP =
    'SET_PRODUCTGUIDE_UNSAVED_CHANGES_POP_UP';
export const SET_ROUTE_PATH_FOR_PRODUCTGUIDE_UNSAVED_CHANGES_POP_UP =
    'SET_ROUTE_PATH_FOR_PRODUCTGUIDE_UNSAVED_CHANGES_POP_UP';
export const SET_TEMPLATES_UNSAVED_CHANGES_POP_UP =
    'SET_TEMPLATES_UNSAVED_CHANGES_POP_UP';
export const SET_ROUTE_PATH_FOR_TEMPLATES_UNSAVED_CHANGES_POP_UP =
    'SET_ROUTE_PATH_FOR_TEMPLATES_UNSAVED_CHANGES_POP_UP';
export const SET_SETTINGS_VALUE = 'SET_SETTINGS_VALUE';

// Set compact view toggle button
export const SET_COMPACT_VIEW_TOGGLE = 'SET_COMPACT_VIEW_TOGGLE';

// Reject set
export const REJECT_SET = 'REJECT_SET';
export const REJECT_SET_SUCCESS = 'REJECT_SET_SUCCESS';
export const REJECT_SET_FAILURE = 'REJECT_SET_FAILURE';
export const CLEAR_REJECT_SET = 'CLEAR_REJECT_SET';

export const GET_REJECT_SET_REASONS = 'GET_REJECT_SET_REASONS';
export const GET_REJECT_SET_REASONS_SUCCESS = 'GET_REJECT_SET_REASONS_SUCCESS';
export const GET_REJECT_SET_REASONS_FAILURE = 'GET_REJECT_SET_REASONS_FAILURE';

export const setCompactViewToggle = (payload) => {
    return {
        type: SET_COMPACT_VIEW_TOGGLE,
        payload: payload,
    };
};

// Set hide view toggle button
export const SET_HIDE_CONDENSED_VIEW_TOGGLE = 'SET_HIDE_CONDENSED_VIEW_TOGGLE';

export const setHideCondensedViewTogggle = (payload) => {
    return {
        type: SET_HIDE_CONDENSED_VIEW_TOGGLE,
        payload: payload,
    };
};

export const setUnsavedChange = (payload) => {
    return {
        type: SET_UNSAVED_CHANGES,
        payload: payload,
    };
};
export const setPopupCloseFromHeader = (payload) => {
    return {
        type: SET_POPUPCLOSE_FROM_HEADER,
        payload: payload,
    };
};
export const setPhysicianPopupCloseFromHeader = (payload) => {
    return {
        type: SET_PHYSICIAN_POPUPCLOSE_FROM_HEADER,
        payload: payload,
    };
};

export const setCommonCancel = (payload) => {
    return {
        type: SET_COMMON_CANCEL,
        payload: payload,
    };
};

export const getCalendarSettings = (data) => {
    return {
        type: GET_CALENDAR_SETTINGS,
        payload: data,
    };
};

export const setIsDelete = (data) =>{
    return {
        type: SET_IS_DELETE,
        payload:data,
    };
};

export const getAnnouncements = () => {
    return {
        type: GET_ANNOUNCEMENTS,
    };
};

export const setCalendarSettings = (data) => {
    return {
        type: SET_CALENDAR_SETTINGS,
        payload: data,
    };
};

export const setSettingsUpdateInProgress = (data) => {
    return {
        type: SET_SETTINGS_POP_UP,
        payload: data,
    };
};
export const setShowPopup = (data) => {
    return {
        type: SHOW_POPUP,
        payload: data,
    };
};
export const setSelectedAccount = (data) => {
    return {
        type: SELECTED_ACCOUNT_DETAILS,
        payload: data,
    };
};
export const getNewGeneratedLink = () => {
    return {
        type: GENERATE_NEW_CALENDAR_SHARING_LINK,
    };
};

export const clearCalendarSharingLink = () => {
    return {
        type: CLEAR_CALENDAR_SHARING_LINK,
    };
};

export const setCancelCalendarSharingAction = (cancelSharingData) => {
    return {
        type: SET_CANCEL_CALENDAR_SHARING,
        payload: cancelSharingData,
    };
};

export const getAccountDetails = (payload, fromSearch) => {
    return {
        type: GET_ACCOUNT_DATA,
        payload: payload,
        fromSearch: fromSearch,
    };
};

export const setAccountFilterOpen = (payload) => {
    return {
        type: SET_ACCOUNT_FILTER,
        payload: payload,
    };
};

export const setAccountSearchOpen = (payload) => {
    return {
        type: SET_ACCOUNT_SEARCH,
        payload: payload,
    };
};

export const setShowLocalExpandedView = (payload) => {
    return {
        type: SET_LOCAL_EXPANDED_VIEW,
        payload: payload,
    };
};

export const getFilterData = (payload) => {
    return {
        type: GET_FILTER_DATA,
        payload: payload,
    };
};

export const clearPhysicianDetails = () => {
    return {
        type: SET_CLEAR_PHYSICIAN_DETAILS,
    };
};

// export const getShipToAddressDetails = () => {
//     return {
//         type: GET_SHIP_TO_ADDRESS_DATA,
//     };
// };
export const setShowUnsaved = (payload) => {
    return {
        type: SET_SHOW_UNSAVED,
        payload: payload,
    };
};
export const setIsEdit = (payload) => {
    return {
        type: SET_ISEDIT,
        payload: payload,
    };
};
export const setFavoriteIcon = (id, value, isAssoicate, fromSearch, selectedTerritorycode) => {
    return {
        type: SET_FAVORITE,
        payload: id,
        value,
        isAssoicate: isAssoicate,
        fromSearch: fromSearch,
        selectedTerritorycode:selectedTerritorycode
    };
};
export const setSearchParams = (payload) => {
    return {
        type: SET_SEARCH_PARAMS,
        payload: payload,
    };
};
export const setShowExpandedView = (updatedView) => {
    return {
        type: SET_SHOW_EXPANDED_VIEW,
        payload: updatedView,
    };
};
export const setFilterAppliedView = (payload) => {
    return {
        type: SET_FILTER_VIEW,
        payload: payload,
    };
};
export const setFilterAppliedViewPhy = (payload) => {
    return {
        type: SET_FILTER_VIEW_PHYSICIAN,
        payload: payload,
    };
};

export const setMoreClick = (payload) => {
    return {
        type: SET_MORE_CLICK,
        payload: payload,
    };
};
export const getAccountDetailss = (payload) => {
    return {
        type: GET_ACCOUNT_DETAILS,
        payload: payload,
    };
};

export const updateAccountDetails = (params, value) => {
    return {
        type: UPDATE_ACCOUNT_DETAILS,
        payload: params,
        carrierValue: value,
    };
};

export const getLinks = (payload) => {
    return {
        type: GET_LINKS,
        payload: payload,
    };
};

export const setClearFilter = (payload) => {
    return {
        type: SET_CLEAR_FILTER,
        payload: payload,
    };
};

export const getPhysicianDetailss = (payload) => {
    return {
        type: GET_PHYSICIAN_DETAILS,
        payload: { ...payload },
    };
};

export const getPhysicianDetails = (payload, fromSearch) => {
    return {
        type: GET_PHYSICIAN_DATA,
        payload: payload,
        fromSearch: fromSearch,
    };
};

export const setTemplateSearchOpen = (payload) => {
    return {
        type: SET_TEMPLATE_SEARCH,
        payload: payload,
    };
};

export const setPhysicianSearchOpen = (payload) => {
    return {
        type: SET_PHYSICIAN_SEARCH,
        payload: payload,
    };
};

export const setPhysicianFilterOpen = (payload) => {
    return {
        type: SET_PHYSICIAN_FILTER,
        payload: payload,
    };
};
export const getFilterDataPhy = (payload) => {
    return {
        type: PHY_FILTER_OPEN,
        payload: payload,
    };
};
export const setFavoritePhysician = (
    id,
    value,
    isAssoicate,
    isFromAccount,
    isFromSearch
) => {
    return {
        type: SET_FAVORITE_PHYSICIAN,
        payload: id,
        value,
        isAssoicate: isAssoicate,
        isFromAccount: isFromAccount,
        isFromSearch: isFromSearch,
    };
};

export const updatePhysicianNotes = (params) => {
    return {
        type: UPDATE_PHYSICIAN_NOTE,
        payload: params,
    };
};
export const setSearchParamsPhy = (payload) => {
    return {
        type: SET_SEARCH_PARAMS_PHY,
        payload: payload,
    };
};

export const setPhysicianDetailTabAction = (tabType) => {
    return {
        type: SET_PHYSICIAN_DETAIL_TAB,
        data: tabType,
    };
};

export const closePhysicianPopUP = (modalState) => {
    return {
        type: CLOSE_PHYSICIAN_POPUP,
        payload: modalState,
    };
};
export const showAccountDetails = (modalState) => {
    return {
        type: SHOW_ACCOUNT_DETAIL_POPUP,
        payload: modalState,
    };
};
export const setAccountDetailTabAction = (tabType) => {
    return {
        type: SET_ACCOUNT_DETAIL_TAB,
        data: tabType,
    };
};

export const getDistrict = (data) => {
    return {
        type: GET_DISTRICT,
        payload: data,
    };
};
export const getDistrictPhysician = (data) => {
    return {
        type: GET_DISTRICT_PHYSICIAN,
        payload: data,
    };
};
export const getTerritory = (district) => {
    return {
        type: GET_TERRITORY,
        payload: district,
    };
};
export const getAccounts = (accountParams) => {
    return {
        type: GET_ACCOUNTS,
        payload: accountParams,
    };
};
export const getAccountsList = (accountParams) => {
    return {
        type: GET_ACCOUNTS_LIST,
        payload: accountParams,
    };
};
export const resetAccounts = () => {
    return {
        type: RESET_ACCOUNTS,
    };
};
export const resetAccountsList = () => {
    return {
        type: RESET_ACCOUNTS_LIST,
    };
};
export const resetTerritory = () => {
    return {
        type: RESET_TERRITORY,
    };
};

export const resetAccountFilterState = () => ({
    type: RESET_ACCOUNT_FILTER_STATE,
});

export const restoreAccountFilterState = (snapshot) => ({
    type: RESTORE_ACCOUNT_FILTER_STATE,
    payload: snapshot,
});

export const resetPhysicianFilterState = () => ({
    type: RESET_PHYSICIAN_FILTER_STATE,
});

export const restorePhysicianFilterState = (snapshot) => ({
    type: RESTORE_PHYSICIAN_FILTER_STATE,
    payload: snapshot,
});

export const setAppliedFilter = (appliedFilters) => {
    return {
        type: SET_APPLIED_VIEW_ACCOUNT_FILTER,
        payload: appliedFilters,
    };
};

export const actionApplyFilterType = (filterType) => {
    return {
        type: SET_FILTER_TYPE,
        payload: filterType,
    };
};

export const closeAccountPopUP = (modalState) => {
    return {
        type: CLOSE_ACCOUNT_POPUP,
        payload: modalState,
    };
};

export const setSpecialityList = (payload) => {
    return {
        type: SET_SPECIALITY_LIST,
        payload: payload,
    };
};

export const setAccountFilters = (payload) => {
    return {
        type: SET_ACCOUNT_FILTERS,
        payload: payload,
    };
};

export const setAccountFilterSnapshot = (payload) => {
    return {
        type: SET_ACCOUNT_FILTER_SNAPSHOT,
        payload: payload,
    };
};

export const setPhysicianFilterSnapshot = (payload) => {
    return {
        type: SET_PHYSICIAN_FILTER_SNAPSHOT,
        payload: payload,
    };
};

export const setTemplateFilterSnapshot = (payload) => {
    return {
        type: SET_TEMPLATE_FILTER_SNAPSHOT,
        payload: payload,
    };
};

export const setExpandedAccountViews = (payload) => {
    return {
        type: SET_ACCOUNT_EXPAND_VIEW,
        payload: payload,
    };
};

export const setAccountFilterParams = (payload) => {
    return {
        type: SET_FILTER_PARAMS,
        payload: payload,
    };
};

export const setPhysicianFilters = (payload) => {
    return {
        type: SET_PHYSICIAN_ACCOUNT_FILTER,
        payload: payload,
    };
};

export const setSpecialityFilterData = (payload) => {
    return {
        type: SET_SPECIALTY_FILTER_DATA,
        payload: payload,
    };
};

export const setLocalExpandedFilter = (payload) => {
    return {
        type: SET_SPECIALTY_EXPAND,
        payload: payload,
    };
};

export const setSelectedPhysician = (payload) => {
    return {
        type: SET_SELECTED_PHYSICIAN,
        payload: payload,
    };
};

export const setSelectedOption = (payload) => {
    return {
        type: SET_SELECTED_OPTION,
        payload: payload,
    };
};

export const surgeryScreen = (payload) => {
    return {
        type: SET_SURGERY_SCREEN,
        payload: payload,
    };
};

export const equityScreen = (payload) => {
    return {
        type: SET_EQUITY_SCREEN,
        payload: payload,
    };
};
export const getProductsTemplatesFilter = () => {
    return {
        type: GET_PRODUCTSTEMPLATESFILTER,
    };
};

export const setProductsTemplatesFilter = (productsTemplatesFilter) => {
    return {
        type: SET_PRODUCTSTEMPLATESFILTER,
        payload: productsTemplatesFilter,
    };
};

export const setExpandedFilters = (data) => {
    return {
        type: SET_EXPANDED_FILTER_VIEW,
        payload: data,
    };
};
export const getAccountDataSearch = (payload) => {
    return {
        type: GET_ACCOUNT_DATA_FROM_SEARCH,
        payload: payload,
    };
};
export const getPhysicianDataSearch = (payload) => {
    return {
        type: GET_PHYSICIAN_DATA_FROM_SEARCH,
        payload: payload,
    };
};
export const setAppliedFilterPhysician = (appliedFilters) => {
    return {
        type: SET_APPLIED_VIEW_PHY_FILTER,
        payload: appliedFilters,
    };
};
export const setAccountFilterParamValues = (payload) => {
    return {
        type: SET_ACCOUNT_FILTER_PARAM_VALUES,
        payload: payload,
    };
};
export const setPhysicianFilterParamValues = (payload) => {
    return {
        type: SET_PHYSICIAN_FILTER_PARAM_VALUES,
        payload: payload,
    };
};
export const setShipToAddressEdit = (payload) => {
    return {
        type: SET_SHIP_TO_ADDRESS_EDIT,
        payload: payload,
    };
};

export const setFilterPage = (payload) => {
    return {
        type: SET_FILTER_PAGE,
        payload: payload,
    };
};

export const getDetailedProductTemplateList = (params) => {
    return {
        type: GET_DETAILED_PRODUCT_TEMPLATE_LIST,
        payload: params,
    };
};
export const setUnsavedChangePhysician = (payload) => {
    return {
        type: SET_UNSAVED_CHANGES_PHYSICIAN,
        payload: payload,
    };
};
export const setShowUnsavedPhysician = (payload) => {
    return {
        type: SET_SHOW_UNSAVED_PHYSICIAN,
        payload: payload,
    };
};

export const setShowPopupPhy = (payload) => {
    return {
        type: SET_SHOW_POPUP_PHYSICIAN,
        payload: payload,
    };
};
export const setFromAccountSearch = (payload) => {
    return {
        type: SET_FROM_ACCOUNT_SEARCH,
        payload: payload,
    };
};
export const getPhysicianFavouriteStatus = (payload) => {
    return {
        type: GET_PHYSICIAN_FAV_STATUS,
        payload: payload,
    };
};
export const getAccountFavouriteStatus = (payload) => {

    return {
        type: GET_ACCOUNT_FAV_STATUS,
        payload: payload,
    };
};

export const getSpecialtyList = (payload) => {
    return {
        type: GET_SPECIALTY_FILTER_DATA,
        payload: payload,
    };
};
export const setTemplateNote = (payload) => {
    return {
        type: SET_TEMPLATE_NOTE,
        payload: payload,
    };
};
export const setTemplateNoteAccount = (payload) => {
    return {
        type: SET_TEMPLATE_NOTE_ACCOUNT,
        payload: payload,
    };
};
export const setTemplateNoteChangeAccount = (payload) => {
    return {
        type: SET_TEMPLATE_NOTE_CHANGE_ACCOUNT,
        payload: payload,
    };
};
export const setTemplateNoteChangePhysician = (payload) => {
    return {
        type: SET_TEMPLATE_NOTE_CHANGE_PHYSICIAN,
        payload: payload,
    };
};
export const setViewValues = (payload) => {
    return {
        type: SET_VIEW_VALUES,
        payload: payload,
    };
};
export const setCheckBoxValues = (payload) => {
    return {
        type: SET_CHECKBOX_VALUES,
        payload: payload,
    };
};

export const setAnnouncementUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ANNOUNCEMENT_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setRoutePathForAnnouncementUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_ANNOUNCEMENT_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setAccountUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ACCOUNT_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setRoutePathForAccountUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_ACCOUNT_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setLinksUnsavedChangesPopUp = (value) => {
    return {
        type: SET_LINKS_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setRoutePathForLinksUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_LINKS_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setPhysiciansUnsavedChangesPopUp = (value) => {
    return {
        type: SET_PHYSICIANS_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setRoutePathForPhysiciansUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_PHYSICIANS_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setProxiesUnsavedChangesPopUp = (value) => {
    return {
        type: SET_PROXIES_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setRoutePathForProxiesUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_PROXIES_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setProductGuideUnsavedChangesPopUp = (value) => {
    return {
        type: SET_PRODUCTGUIDE_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setRoutePathForProductGuideUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_PRODUCTGUIDE_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setTemplatesUnsavedChangesPopUp = (value) => {
    return {
        type: SET_TEMPLATES_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setRoutePathForTemplatesUnsavedChangesPopUp = (value) => {
    return {
        type: SET_ROUTE_PATH_FOR_TEMPLATES_UNSAVED_CHANGES_POP_UP,
        payload: value,
    };
};

export const setSettingsValue = (value) => {
    return {
        type: SET_SETTINGS_VALUE,
        payload: value,
    };
};

// Reject set
export const rejectSet = (payload) => {
    return {
        type: REJECT_SET,
        payload,
    };
};

export const resetRejectSet = () => {
    return {
        type: CLEAR_REJECT_SET,
    };
};
// Field Inventory Dashboard Actions

export const GET_FIELD_INVENTORY_DASHBOARD = 'FIELD_INVENTORY: GET_FIELD_INVENTORY_DASHBOARD';
export const GET_FIELD_INVENTORY_DASHBOARD_SUCCESS = 'FIELD_INVENTORY: GET_FIELD_INVENTORY_DASHBOARD_SUCCESS';
export const GET_FIELD_INVENTORY_DASHBOARD_FAILURE = 'FIELD_INVENTORY: GET_FIELD_INVENTORY_DASHBOARD_FAILURE';
export const RESET_FIELD_INVENTORY_DASHBOARD = 'FIELD_INVENTORY: RESET_FIELD_INVENTORY_DASHBOARD';
export const ADD_FIM_NOTES = 'FIELD_INVENTORY: ADD_FIM_NOTES';
export const ADD_FIM_NOTES_SUCCESS = 'FIELD_INVENTORY: ADD_FIM_NOTES_SUCCESS';
export const ADD_FIM_NOTES_FAILURE = 'FIELD_INVENTORY: ADD_FIM_NOTES_FAILURE';
export const GET_FIM_NOTES = 'FIELD_INVENTORY: GET_FIM_NOTES';  
export const GET_FIM_NOTES_SUCCESS = 'FIELD_INVENTORY: GET_FIM_NOTES_SUCCESS';
export const GET_FIM_NOTES_FAILURE = 'FIELD_INVENTORY: GET_FIM_NOTES_FAILURE';
export const EDIT_FIM_NOTES = 'FIELD_INVENTORY: EDIT_FIM_NOTES';
export const EDIT_FIM_NOTES_SUCCESS = 'FIELD_INVENTORY: EDIT_FIM_NOTES_SUCCESS';
export const EDIT_FIM_NOTES_FAILURE = 'FIELD_INVENTORY: EDIT_FIM_NOTES_FAILURE';
export const RESET_FIM_NOTES = 'FIELD_INVENTORY: RESET_FIM_NOTES';
export const DASHBOARD_EXPORT = 'FIELD_INVENTORY: DASHBOARD_EXPORT';
export const DASHBOARD_EXPORT_SUCCESS = 'FIELD_INVENTORY: DASHBOARD_EXPORT_SUCCESS';
export const DASHBOARD_EXPORT_FAILURE = 'FIELD_INVENTORY: DASHBOARD_EXPORT_FAILURE';
export const RESET_DASHBOARD_EXPORT = 'FIELD_INVENTORY: RESET_DASHBOARD_EXPORT';

export const getFieldInventoryDashboard = (params = {}) => {
return  {
    type : GET_FIELD_INVENTORY_DASHBOARD,
    payload : params,
};
};


export const getFieldInventoryDashboardFailure = (error) => {
    return {
        type: GET_FIELD_INVENTORY_DASHBOARD_FAILURE,
        payload: error,
    };
};
export const resetFieldInventoryDashboard = () => {
    return {
        type: RESET_FIELD_INVENTORY_DASHBOARD,
    };
};

// FIM Notes Action Creators
export const addFimNotes = (data) => {
    return {
        type: ADD_FIM_NOTES,
        payload: data,
    };
};

export const addFimNotesSuccess = (data) => {
    return {
        type: ADD_FIM_NOTES_SUCCESS,
        payload: data,
    };
};

export const addFimNotesFailure = (error) => {
    return {
        type: ADD_FIM_NOTES_FAILURE,
        payload: error,
    };
};

export const getFimNotes = (params = {}) => {
    return {
        type: GET_FIM_NOTES,
        payload: params,
    };
};

export const getFimNotesSuccess = (data) => {
    return {
        type: GET_FIM_NOTES_SUCCESS,
        payload: data,
    };
};

export const getFimNotesFailure = (error) => {
    return {
        type: GET_FIM_NOTES_FAILURE,
        payload: error,
    };
};

export const editFimNotes = (data) => {
    return {
        type: EDIT_FIM_NOTES,
        payload: data,
    };
};

export const editFimNotesSuccess = (data) => {
    return {
        type: EDIT_FIM_NOTES_SUCCESS,
        payload: data,
    };
};

export const editFimNotesFailure = (error) => {
    return {
        type: EDIT_FIM_NOTES_FAILURE,
        payload: error,
    };
};

export const resetFimNotes = () => {
    return {
        type: RESET_FIM_NOTES,
    };
};

// Dashboard Filters actions
export const FETCH_FILTERS_REQUEST = 'DASHBOARD_FILTERS: FETCH_FILTERS_REQUEST';
export const FETCH_FILTERS_SUCCESS = 'DASHBOARD_FILTERS: FETCH_FILTERS_SUCCESS';
export const FETCH_FILTERS_FAILURE = 'DASHBOARD_FILTERS: FETCH_FILTERS_FAILURE';

export const UPDATE_FILTER = 'DASHBOARD_FILTERS: UPDATE_FILTER';

export const SAVE_FILTERS_REQUEST = 'DASHBOARD_FILTERS: SAVE_FILTERS_REQUEST';
export const SAVE_FILTERS_SUCCESS = 'DASHBOARD_FILTERS: SAVE_FILTERS_SUCCESS';
export const SAVE_FILTERS_FAILURE = 'DASHBOARD_FILTERS: SAVE_FILTERS_FAILURE';

export const fetchFiltersRequest = () => ({ type: FETCH_FILTERS_REQUEST });

export const updateFilter = (value) => ({
    type: UPDATE_FILTER,
    payload:value,
});

export const saveFiltersRequest = (data) => ({
    type: SAVE_FILTERS_REQUEST, 
    payload: data
});

export const RESET_DASHBOARD_FILTERS = 'DASHBOARD_FILTERS: RESET';
export const resetDashboardFilters = () => ({ type: RESET_DASHBOARD_FILTERS });

// Dashboard List actions
export const GET_DASHBOARD_LIST = 'FIELD_INVENTORY: GET_DASHBOARD_LIST';
export const GET_DASHBOARD_LIST_SUCCESS = 'FIELD_INVENTORY: GET_DASHBOARD_LIST_SUCCESS';
export const GET_DASHBOARD_LIST_FAILURE = 'FIELD_INVENTORY: GET_DASHBOARD_LIST_FAILURE';
export const SET_FIM_FILTER_DATES = 'FIELD_INVENTORY: SET_FIM_FILTER_DATES';
export const RESET_DEFAULT_DATE = 'FIELD_INVENTORY: RESET_DEFAULT_DATE';

export const getDashboardList = (params = {}) => ({
    type: GET_DASHBOARD_LIST,
    payload: params,
});

export const dashboardExport = (params = {}) => ({
    type: DASHBOARD_EXPORT,
    payload: params,
});

export const dashboardExportSuccess = (data) => ({
    type: DASHBOARD_EXPORT_SUCCESS,
    payload: data,
});

export const dashboardExportFailure = (error) => ({
    type: DASHBOARD_EXPORT_FAILURE,
    payload: error,
});
// Allocation Details Actions
export const GET_ALLOCATION_DETAILS = 'FIELD_INVENTORY: GET_ALLOCATION_DETAILS';
export const GET_ALLOCATION_DETAILS_SUCCESS = 'FIELD_INVENTORY: GET_ALLOCATION_DETAILS_SUCCESS';
export const GET_ALLOCATION_DETAILS_FAILURE = 'FIELD_INVENTORY: GET_ALLOCATION_DETAILS_FAILURE';
export const RESET_ALLOCATION_DETAILS = 'FIELD_INVENTORY: RESET_ALLOCATION_DETAILS';

export const getAllocationDetails = (params) => ({
    type: GET_ALLOCATION_DETAILS,
    payload: params,
});

export const resetAllocationDetails = () => ({
    type: RESET_ALLOCATION_DETAILS,
});

// Allocate Set Actions
export const ALLOCATE_SET = 'FIELD_INVENTORY: ALLOCATE_SET';
export const ALLOCATE_SET_SUCCESS = 'FIELD_INVENTORY: ALLOCATE_SET_SUCCESS';
export const ALLOCATE_SET_FAILURE = 'FIELD_INVENTORY: ALLOCATE_SET_FAILURE';
export const RESET_ALLOCATE_SET = 'FIELD_INVENTORY: RESET_ALLOCATE_SET';

export const allocateSet = (params) => ({
    type: ALLOCATE_SET,
    payload: params,
});

export const resetAllocateSet = () => ({
    type: RESET_ALLOCATE_SET,
});

export const setFimFilterDates = (dates) => ({
    type: SET_FIM_FILTER_DATES,
    payload: dates,
});

export const resetDefaultDate = () => ({
    type: RESET_DEFAULT_DATE,
});

export const GET_SET_DETAILS = 'FIELD_INVENTORY: GET_SET_DETAILS';
export const GET_SET_DETAILS_SUCCESS = 'FIELD_INVENTORY: GET_SET_DETAILS_SUCCESS';
export const GET_SET_DETAILS_FAILURE = 'FIELD_INVENTORY: GET_SET_DETAILS_FAILURE';
export const RESET_SET_DETAILS = 'FIELD_INVENTORY: RESET_SET_DETAILS';

export const getSetDetails = (params = {}) => {
    return {
        type: GET_SET_DETAILS,
        payload: params,
    };
};

export const getSetDetailsSuccess = (data) => {
    return {
        type: GET_SET_DETAILS_SUCCESS,
        payload: data,
    };
};

export const getSetDetailsFailure = (error) => {
    return {
        type: GET_SET_DETAILS_FAILURE,
        payload: error,
    };
};

export const resetSetDetails = () => {
    return {
        type: RESET_SET_DETAILS,
    };
};

export const getRejectSetReasons = () => {
    return {
        type: GET_REJECT_SET_REASONS,
    };
};